<template>

</template>

<script>
import axios from "axios";
import apis from "@/configs/apis";
import Prompt from "@/views/erp/mixins/Prompt";
import { EventBus } from "@/views/erp/utils/event-bus";

export default {
  mixins: [Prompt],
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    emailInvoice(invoice) {
      this.$confirm('Confirm send invoice?', 'Email Invoice: ' + invoice.invoiceNumber)
        .then(() => {
          return axios.post(apis.erpInvoices + '/' + invoice.id + '/email', this.newItem)
        })
        .then(response => {
          this.promptInfo('Invoice Email Sent');
          EventBus.$emit("invoice-updated");
        })
        .catch(e => {
          if (e === 'cancel') return;
          this.promptError(e);
        });
    },
  }
}
</script>